cb.define(['common/common_VM.Extend.js'], function () {

    var PM_pmc_giftcard_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {
            var nowDates = new Date().format('yyyy-MM-dd');
            viewmodel.get('cImgName').setState('tooltip', '支持PNG、JPG、JPGE格式，建议使用720*400px，大小不超过2M');

            const displayPrompt = (mode) => {
                if (mode == 'browse') {
                    viewmodel.get('giftCardCode').setState('after', null);
                } else {
                    viewmodel.get('giftCardCode').setState('after', '4位字母或数字组合');
                }
            }

            viewmodel.on("modeChange", function (data) {
                displayPrompt(data)
            })

            viewmodel.on('afterLoadData', function (data) {
                let mode = viewmodel.getParams().mode;
                displayPrompt(mode);
            });

            //面额修改控制事件
            viewmodel.get('reduceAmount').on('afterValueChange', function (data) {
                viewmodel.get('salePrice').setValue(data.value);
            });
            //礼品号码控制
            viewmodel.get('giftCardCode').on('beforeValueChange', function (data) {
                var giftCardCode = data.value;
                if (giftCardCode != null) {
                    if (giftCardCode.toString().length != 4 || giftCardCode.match(/^[0-9a-zA-Z]*$/g) != giftCardCode) {
                        cb.utils.alert('礼品卡号码必须为4位字母或数字组合', 'warning');
                        return false;
                    }
                }
            });
            viewmodel.get('fontColor').on('afterValueChange', function (data) {

            });
            //面额、售价
            viewmodel.get('reduceAmount').setState('min', 1);
            viewmodel.get('salePrice').setState('min', 1);


            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);
                // if(mode == 'add'){
                // 	if(obj.expireStartDate < nowDates){
                // 		cb.utils.alert('开始时间大于当前时间', 'warning');
                // 		return false;
                // 	}
                // }

                if (obj.expireStartDate >= obj.expireEndDate) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                data.data.data = JSON.stringify(obj);

            });
        }
    };
    try {
        module.exports = PM_pmc_giftcard_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_giftcard_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_giftcard_VM.Extend.js